import { createContext, useContext } from 'react';
import type { UseTelegramAuthResult } from '../hooks/useTelegramAuth';

export const AuthStateContext = createContext<UseTelegramAuthResult | null>(null);

export function useAuthState(): UseTelegramAuthResult {
  const ctx = useContext(AuthStateContext);
  if (!ctx) {
    throw new Error('useAuthState must be used within AuthStateContext provider');
  }
  return ctx;
}

